import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Fade } from "react-bootstrap";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import toast from "react-hot-toast";

import CustomTableV2 from "../../common/CustomTableV2";
import CustomButton from "../../common/CustomButton";
import CustomSliderModalV2 from "../../common/CustomSliderModalV2";
import ProgramInfo from "./components/ProgramInfo";

import { GetIndiPrograms } from "../../redux/program/actions";

import "./style.css";

function IndiPrograms(props) {
    const [showModal, setShowModal] = useState(false);
    const [selectedProgram, setSelectedProgram] = useState(null);

    return (
        <>
            <div id="indi-program-wrapper" className="main-container">
                <Fade in={true}>
                    <div>
                        <CustomTableV2
                            title="INDI PROGRAMS"
                            description="Add and Update Indi Programs."
                            store={props.Program}
                            table={{
                                headers: [
                                    { title: "#" },
                                    { title: "Name" },
                                    { title: "Type" },
                                    { title: "Timeline" },
                                    { title: "# of Workouts" },
                                    { title: "Levels" },
                                    { title: "" },
                                ],
                                body: (ip, i) => {
                                    // ("ip", ip);
                                    return (
                                        <tr className={i % 2 == 0 ? "tr-even" : ""}>
                                            <td><h5>{i}</h5></td>
                                            <td><h5>{ip.title.toUpperCase()}</h5></td>
                                            <td><h5>{ip.type.toUpperCase()}</h5></td>
                                            <td><h5>{ip.timeline.toUpperCase()}</h5></td>
                                            <td><h5>{ip.count}</h5></td>
                                            <td>
                                                <h5>
                                                    {(ip.beginner && "BEGINNER")}{ip.moderate && ", MODERATE"}{ip.advanced && ", ADVANCED"}
                                                </h5>
                                            </td>
                                            <td><ArrowForwardIosIcon id="view-arrow" onClick={async () => {
                                                setSelectedProgram(ip);
                                                setShowModal(true);
                                            }} /></td>
                                        </tr>
                                    )
                                }
                            }}

                            actions={{
                                get: (page, count, filter, sort) => {
                                    props.GetIndiPrograms(page, count, filter, sort);
                                },
                                // add: () => {
                                //     setShowModal(true);
                                // },
                            }}
                        />
                    </div>
                </Fade>
            </div>

            <CustomSliderModalV2 show={showModal} setShow={setShowModal} title={"Program Info"}>
                <ProgramInfo program={selectedProgram} />
            </CustomSliderModalV2>
        </>
    );
}

const mapStateToProps = (state) => ({
    Program: state.Program
})

export default connect(mapStateToProps, {
    GetIndiPrograms,
})(IndiPrograms);
